module.exports = __webpack_public_path__ + "static/media/21ECLAC26.19c3cb50.jpg";